import { RowItemAttributes } from '@/types'
import { CreateRowItemMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData
  } = useForm<CreateRowItemMutation, RowItemAttributes, never, never>({
    defaultValues: {
      name: '',
      priceCents: 0,
    },
    mutation: CreateMutation,
    resultKey: 'createRowItem',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.createRowItem?.rowItem?.id) return

    navigate(`/extra-items/${mutationData?.createRowItem?.rowItem?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        { formBuilder.buildField({ name: 'Price', field: 'priceCents', type: 'currency' }) }
      </div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
